import array from './array.js';
import func from './function.js';
import number from './number.js';
import object from './object.js';
import string from './string.js';

export default {
    array, function: func, number, object, string
};